"use client"

import { ThumbsUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ThumbsUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ThumbsUpIcon = component(Icon)({ as: ThumbsUp })
